import {DigitizationTools} from "../ToolRegistry.js";

import {T} from "../i18n/index.js";
// POI (inspektionspunkt): en almindelig Point-registrering med et eget værktøj-id, så den bor i Feature-/Registreringssystemet
// (træ, gem/eksport, host-API) som alt andet. Det, der gør den til en POI - status, kategori, ansvarlig, frist, fotos, gemt
// kamera - ligger i `properties.attributes` (faglige felter) og `domainData.poi` (værktøjssemantik); frontendens POI-modul
// (utils/poi-*.js) ejer det og gemmer det pr. punktsky. Selve nålen i 3D tegnes af frontenden (DOM-lag), så markøren her er den
// almindelige punkt-markør, der blot forankrer nålen til overfladen.
export const PoiTool = {
	id: "digitize_poi",
	name: T("POI"),
	category: "basic",
	kind: "registration",
	toolbarGroup: "registration",
	toolbarOrder: 15,
	icon: "digitize_poi.svg",
	resultGeometryType: "Point",
	featureType: "POI",
	maxPoints: 1,
	tooltip: T("Opret et inspektionspunkt (POI) med status, noter og fotos ved at vælge en position i punktskyen."),
	instructions: T("Venstreklik på punktskyen for at placere POI'en."),
};

DigitizationTools.register(PoiTool);
